import { type FC, type ReactNode, useMemo } from "react";
import { useApolloClient } from "@apollo/client";

import { createPaginationContext, createPaginationService } from "../../common/state";

import { loadGroups } from "./loadGroups";

export const GroupListPaginationContext = createPaginationContext();

export const GroupListPaginationProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const client = useApolloClient();

    const paginationService = useMemo(() => createPaginationService(loadGroups(client), { limit: 10 }), [client]);

    return (
        <GroupListPaginationContext.Provider value={paginationService}>{children}</GroupListPaginationContext.Provider>
    );
};
